import { HandHeart, ShieldCheck, Heart, Sun } from "lucide-react";
import { ChapterHeading, FadeUp } from "./shared";

const PILLARS = [
    { icon: HandHeart, title: "Cuidado Dedicado", text: "Estou presente e atenta, com um plano individualizado em cada atendimento." },
    { icon: ShieldCheck, title: "Respeito", text: "Coloco a dignidade, a história e a vontade da pessoa idosa sempre em primeiro lugar." },
    { icon: Heart, title: "Acolhimento", text: "Escuto com sensibilidade e abraço idosos e famílias em cada etapa." },
    { icon: Sun, title: "Bem-estar", text: "Trabalho pela autonomia, saúde mental e qualidade de vida como metas do cuidar." },
];

const PillarsSection = () => (
    <section id="pilares" className="relative py-20 sm:py-28" data-testid="pillars-section">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <ChapterHeading number="04" eyebrow="Pilares" align="center" title={<>Os valores que <span className="italic text-serenity">guiam</span> cada cuidado</>} />
            <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-7 lg:grid-cols-4 lg:gap-8">
                {PILLARS.map((p, i) => (
                    <FadeUp key={p.title} delay={i * 0.12} data-testid={`pillar-${i + 1}`}>
                        <div className="group flex h-full flex-row items-center gap-5 rounded-[1.75rem] border border-lilac/40 bg-white p-5 text-left shadow-md shadow-plum/5 transition-all duration-300 hover:-translate-y-1.5 hover:border-lilac hover:shadow-xl hover:shadow-lilac/20 sm:flex-col sm:items-center sm:gap-0 sm:p-8 sm:text-center">
                            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-lilac/50 bg-gradient-to-br from-lav/60 to-serenitylight/40 text-plum transition-transform duration-300 group-hover:scale-110 sm:h-16 sm:w-16">
                                <p.icon size={24} strokeWidth={1.6} />
                            </span>
                            <div>
                                <p className="text-xs font-semibold uppercase tracking-[0.25em] text-serenity sm:mt-4">0{i + 1}</p>
                                <h3 className="mt-1 font-serif text-xl font-semibold text-plum sm:mt-2 sm:text-2xl">{p.title}</h3>
                                <p className="mt-1.5 text-base leading-relaxed text-ink sm:mt-3">{p.text}</p>
                            </div>
                        </div>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);

export default PillarsSection;
